(function($) {

  	// DOM is fully loaded, safe to manipulate elements
  	$(function() {	

		const queryBlock = document.querySelector('.trusler-block--testimonial-query');
		ParcelFunctions.inViewport(queryBlock, 0, 0.15, 'block-in-viewport');

		$('.trusler-block--testimonial-query .t-item').featherlight({
		  	targetAttr: 'data-featherlight', // or whatever
		});  	

	});

})(jQuery);